// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__dDf8O","checkboxCol":"Table_checkboxCol__1WK7K","emailCol":"Table_emailCol__31Z9n","actionCol":"Table_actionCol__1IOW-"};